import "./BonusRangeTable.css";

const BonusRangeTable = ({
  tituloFaixa,
  receitaMin,
  receitaMax,
  valorMinimo,
  valorBonusPotencial,
  valorMaximoPotencial,
}) => {
  const formatarValor = (valor) => {
    if (valor == null || isNaN(valor)) return "R$ 0,00";
    return Number(valor).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const formatarRange = (min, max) => {
    if (min == null || max == null || isNaN(min) || isNaN(max)) return "-";

    if (tituloFaixa === "FAIXA 8") {
      return `${formatarValor(min)}`;
    }
    return `${formatarValor(min)} a ${formatarValor(max)}`;
  };

  return (
    <div className="table-responsive mt-4 bonus-range-table">
      <table className="table bonus-table">
        <thead>
          <tr style={{ backgroundColor: "#005baa", color: "#fff" }}>
            <th className="table-header">{tituloFaixa || "FAIXA"}</th>
            <th className="table-header">
              {formatarRange(receitaMin, receitaMax)}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="bonus-label">VALOR MÍNIMO</td>
            <td>{formatarValor(valorMinimo)}</td>
          </tr>
          <tr>
            <td className="bonus-label">BÔNUS POTENCIAL</td>
            <td>{formatarValor(valorBonusPotencial)}</td>
          </tr>
          <tr>
            <td className="bonus-label">VALOR MÁXIMO POTENCIAL</td>
            <td>{formatarValor(valorMaximoPotencial)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default BonusRangeTable;
